import { Button } from '@progress/kendo-react-buttons';
import { WarningCircleOutline } from '../../../../../icons/icons';
import { useAppSelector } from '../../../../hooks/store-hooks';
import './NetworkToolbarItem.css';

export function NetworkToolbarItem() {
    const offline = useAppSelector((x) => x.global.network.offline);

    if (!offline) {
        return null;
    }

    return (
        <Button
            style={{
                width: 27,
                height: 27,
                animation: 'bg-network-issue-anim 2s infinite'
            }}
            title="Network issues"
            className="k-rounded-full"
            data-tooltip-bottom
            svgIcon={WarningCircleOutline}
        />
    );
}
